import { render, staticRenderFns } from "./PropertyTypeForm.vue?vue&type=template&id=46d94aed&"
import script from "./PropertyTypeForm.vue?vue&type=script&lang=js&"
export * from "./PropertyTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports